import { createSlice } from '@reduxjs/toolkit';
import { getUpcomingLoanPayments } from 'thunks';
import { UpcomingLoanPayment } from 'api/ApplicationDataApi';

export interface UpcomingLoanPaymentsState {
  payments: UpcomingLoanPayment[];
  applicationId: string | null;
  isLoading: boolean;
  isError: boolean;
  errorMessage: string | null;
}

const initialState: UpcomingLoanPaymentsState = {
  payments: [],
  applicationId: null,
  isLoading: false,
  isError: false,
  errorMessage: null,
};

const upcomingLoanPaymentsSlice = createSlice({
  name: 'upcomingLoanPayments',
  initialState,
  reducers: {
    clearUpcomingLoanPayments: (state) => {
      state.payments = [];
      state.applicationId = null;
      state.isError = false;
      state.errorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUpcomingLoanPayments.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = null;
      })
      .addCase(getUpcomingLoanPayments.fulfilled, (state, action) => {
        state.isLoading = false;
        state.payments = action.payload.upcomingPayments;
        state.applicationId = action.meta.arg;
      })
      .addCase(getUpcomingLoanPayments.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.error.message || 'Failed to load upcoming loan payments';
      });
  },
});

export const { clearUpcomingLoanPayments } = upcomingLoanPaymentsSlice.actions;
export default upcomingLoanPaymentsSlice.reducer;
